/**
 * Reads the `content` of the `<meta>` tag with the given name
 * @param {string} name
 * @returns string
 */
export function metaContent(name) {
  return document.querySelector(`meta[name="${name}"]`)?.content;
}
